import React from 'react';

import { StyleUtil } from '../../util';
import classNames from './EABD2LinkButton.module.scss';

type ColorType = 'primary' | 'onBackgroundLighter';

export interface LinkButtonProps
  extends Readonly<{
    text: string;
    arrowPosition: 'before' | 'after';
    arrowDirection: 'left' | 'right';
    color: ColorType;
    onPress: () => void;
    shouldUseSmallerFontSize?: boolean;
    shouldFadeIn?: boolean;
  }> {}

export const LinkButton = React.memo<LinkButtonProps>((props) => {
  const { text, arrowPosition, arrowDirection, color, onPress, shouldUseSmallerFontSize = false, shouldFadeIn = false } = props;

  const RootClassNames = React.useMemo<string>(() => {
    const rootClassNames = StyleUtil.createInitialClassNameArray(classNames.root);

    if (shouldFadeIn) {
      rootClassNames.push(classNames.fadeIn);
    }

    return StyleUtil.mergeClassNames(rootClassNames);
  }, [shouldFadeIn]);

  const ArrowElement = React.useMemo(() => {
    const arrowClassNames = StyleUtil.createInitialClassNameArray(classNames.arrow);

    arrowClassNames.push(classNames[arrowPosition]);
    arrowClassNames.push(classNames[arrowDirection]);
    arrowClassNames.push(classNames[color]);

    return <div className={StyleUtil.mergeClassNames(arrowClassNames)} />;
  }, [arrowPosition, arrowDirection, color]);

  const TextElement = React.useMemo(() => {
    const textClassNames = StyleUtil.createInitialClassNameArray(classNames.text);

    textClassNames.push(classNames[color]);

    if (shouldUseSmallerFontSize) {
      textClassNames.push(classNames.smaller);
    }

    return <span className={StyleUtil.mergeClassNames(textClassNames)}>{text}</span>;
  }, [text, color, shouldUseSmallerFontSize]);

  return (
    <button onClick={onPress} type={'button'} className={RootClassNames}>
      {arrowPosition === 'before' && ArrowElement}
      {TextElement}
      {arrowPosition === 'after' && ArrowElement}
    </button>
  );
});
